<!-- src/views/CustomersView.html -->
<div class="view-container">
  <!-- Header con Titolo e Bottone Aggiungi -->
  <div class="header-section">
    <div>
      <h1 class="view-title">Gestione Clienti</h1>
      <p class="view-desc">Sezione per l'anagrafica dei clienti registrati.</p>
    </div>
    <button class="btn-primary rounded-soft" @click="openDrawer()">
      <Plus :size="18" />
      <span>Nuovo Cliente</span>
    </button>
  </div>

  <!-- Barra di Ricerca -->
  <div class="toolbar-section mb-4">
    <div class="search-box">
      <Search :size="18" class="search-icon" />
      <input 
        type="text" 
        v-model="searchQuery" 
        placeholder="Cerca per nome, cognome, telefono o email..." 
        class="search-input rounded-soft"
      />
    </div>
  </div>

  <!-- Tabella Dati -->
  <div class="table-container rounded-soft shadow-soft">
    <table class="data-table table-customers">
      <thead>
        <tr>
          <th class="col-name">Nome e Cognome</th>
          <th class="col-phone hide-mobile">Cellulare</th>
          <th class="col-email hide-mobile">Email</th>
          <th class="col-status">Stato</th>
          <th class="col-actions">Azioni</th>
        </tr>
      </thead>
      <tbody>
        <!-- Stato Vuoto / Nessun Risultato -->
        <tr v-if="filteredCustomers.length === 0">
          <td colspan="5" class="empty-state">
            {{ searchQuery ? 'Nessun cliente corrisponde alla ricerca.' : 'Nessun cliente trovato. Clicca su "Nuovo Cliente" per aggiungerne uno.' }}
          </td>
        </tr>

        <!-- Ciclo sui Clienti Filtrati -->
        <tr v-for="customer in filteredCustomers" :key="customer.id">
          <td class="font-medium text-light">
            {{ customer.firstName }} {{ customer.lastName }}
          </td>
          <td class="text-muted hide-mobile">{{ customer.phone }}</td>
          <td class="text-muted hide-mobile">{{ customer.email || '-' }}</td>
          <td>
            <span class="status-badge" :class="customer.isActive ? 'status-active' : 'status-inactive'">
              <component :is="customer.isActive ? Check : Minus" :size="14" />
              {{ customer.isActive ? 'Attivo' : 'Inattivo' }}
            </span>
          </td>
          <td class="actions-cell">
            <button class="btn-icon rounded-soft btn-edit" @click="openDrawer(customer)" title="Modifica">
              <Edit :size="16" />
            </button>
            <button class="btn-icon rounded-soft btn-delete" @click="deleteCustomer(customer.id)" title="Elimina">
              <Trash2 :size="16" />
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Overlay per chiudere il Drawer -->
  <div 
    class="drawer-overlay" 
    :class="{ 'is-visible': isDrawerOpen }"
    @click="closeDrawer"
  ></div>

  <!-- Pannello laterale (Drawer) -->
  <div 
    class="drawer"
    :class="{ 'is-open': isDrawerOpen }"
  >
    <div class="drawer-header border-bottom">
      <h2>{{ editingCustomer ? 'Modifica Cliente' : 'Nuovo Cliente' }}</h2>
      <button class="btn-close" @click="closeDrawer">
        <X :size="20" />
      </button>
    </div>
    
    <div class="drawer-body">
      <form @submit.prevent="saveCustomer" id="customer-form">
        <div class="form-row">
          <div class="form-group half-width">
            <label for="firstName">Nome *</label>
            <input 
              type="text" 
              id="firstName" 
              v-model="formFirstName" 
              placeholder="Esempio: Mario" 
              required 
            />
          </div>
          
          <div class="form-group half-width">
            <label for="lastName">Cognome *</label>
            <input 
              type="text" 
              id="lastName" 
              v-model="formLastName" 
              placeholder="Esempio: Rossi" 
              required 
            />
          </div>
        </div>
        
        <div class="form-group">
          <label for="phone">Cellulare *</label>
          <input 
            type="text" 
            id="phone" 
            v-model="formPhone" 
            placeholder="333 1234567" 
            required 
          />
        </div>

        <div class="form-group">
          <label for="email">Email</label>
          <input 
            type="email" 
            id="email" 
            v-model="formEmail" 
            placeholder="mario.rossi@example.com" 
          />
        </div>

        <div class="form-group">
          <label for="whatsapp">WhatsApp</label>
          <input 
            type="text" 
            id="whatsapp" 
            v-model="formWhatsapp" 
            placeholder="Numero WhatsApp..." 
          />
        </div>

        <div class="form-group">
          <label for="telegram">Telegram</label>
          <input 
            type="text" 
            id="telegram" 
            v-model="formTelegram" 
            placeholder="Username Telegram..." 
          />
        </div>

        <div class="form-group checkbox-group">
          <label class="checkbox-label">
            <input 
              type="checkbox" 
              v-model="formIsActive" 
            />
            <span class="custom-checkbox"></span>
            Account Attivo
          </label>
        </div>
      </form>
    </div>
    
    <div class="drawer-footer border-top">
      <button type="button" class="btn-secondary rounded-soft" @click="closeDrawer">
        Annulla
      </button>
      <button type="submit" form="customer-form" class="btn-primary rounded-soft">
        {{ editingCustomer ? 'Aggiorna Cliente' : 'Salva Cliente' }}
      </button>
    </div>
  </div>
</div>